import { CloseDelays } from '@constants/Device';

export const CloseDelayOptions = [CloseDelays.Fast, CloseDelays.Normal, CloseDelays.Slow];
